<div
  class="bfx-field bfx-field-container bfx-field-active-subtle bfx-field-sm-subtle"
  style.width="100%"
>
  <input
    type="number"
    #hours
    min="0"
    max="23"
    (input)="onInput($event)"
    [disabled]="!editingEnabled"
    [(ngModel)]="hour"
    (keydown)="onKeyDown($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    maxlength="2"
    minlength="2"
    class="bfx-field-text bfx-field-placeholder-sm-subtle bfx-field-placeholder-active-subtle time-input"
  />
  :
  <input
    type="number"
    min="0"
    max="59"
    (input)="onInput($event)"
    #minutes
    [disabled]="!editingEnabled"
    [(ngModel)]="minute"
    (keydown)="onKeyDown($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    maxlength="2"
    minlength="2"
    class="bfx-field-text bfx-field-placeholder-sm-subtle bfx-field-placeholder-active-subtle time-input"
  />
  :
  <input
    type="number"
    min="0"
    max="59"
    (input)="onInput($event)"
    #seconds
    [disabled]="!editingEnabled"
    [(ngModel)]="second"
    (keydown)="onKeyDown($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    minlength="2"
    maxlength="2"
    class="bfx-field-text bfx-field-placeholder-sm-subtle bfx-field-placeholder-active-subtle time-input"
  />
</div>
